export default __webpack_public_path__ + "static/media/gallery-wip-t-tracks_00.01fd7415.jpg";